import ModalInformation from "@/app/components/ui/Modals/Information";
import { THEME_MAP, useUITheme } from "@/app/hooks/ui_hooks/useUITheme";
import { UIThemeNamesType } from "@/app_redux/reducers/reducer_interface";
import clsx from "clsx";
import { startCase } from "lodash";
import React from "react";
import { IoColorPaletteOutline } from "react-icons/io5";

const ThemeChangeModal: React.FC<{ className?: string }> = () => {
  const { setTheme, theme } = useUITheme();
  return (
    <ModalInformation
      modalId="UI_THEME_CHANGE_MODAL"
      title={
        <div className="flex justify-start items-center gap-x-2">
          <IoColorPaletteOutline className="w-6 h-6" />
          Change Theme
        </div>
      }
    >
      <div className="p-4 w-full h-full">
        <div>
          <p>Choose your favorite theme to personalize Vetic VMS.</p>
        </div>
        <div className="gap-4 grid grid-cols-3 mt-3">
          {Object.keys(THEME_MAP)?.map((themeName: UIThemeNamesType) => {
            return (
              <button
                onClick={() => setTheme(themeName)}
                className={clsx(
                  "px-3 py-2  rounded-md ",
                  themeName === theme
                    ? "border-2 bg-blue-100 text-blue-600 border-blue-500"
                    : "border border-gray-500 ",
                )}
                key={themeName}
              >
                {startCase(themeName.toLowerCase())}
              </button>
            );
          })}
        </div>
      </div>
    </ModalInformation>
  );
};

export default ThemeChangeModal;
